// @ts-ignore
import loadingGif from "../../../../shared-assets/animations/loading.gif";
// @ts-ignore 
import { useRef } from "react";
import { _c } from "../../../services/text-services";
import GifIcon from "../gif-icon/gif-icon";
import styles from "./spinner.component.module.scss";
interface SpinnerProps {
    type: "full" | "tiny";
    height?: number;
    width?: number;
}
function Spinner({ type, height, width }: SpinnerProps) {
    const customStyle = type === "tiny"
        ? {
            width: width ?? 150,
            height: height ?? 150,
        }
        : {
            width: 500,
            height: 500,            
        };
    const customClasses =
        type === "full" ? "full-spinner" : "tiny-spinner mx-auto";
    const lottieRef = useRef();
    const stopLottie = () => {
        // @ts-ignore: Unreachable code error
        lottieRef.current.stop();
    };
    const playLottie = () => {
        // @ts-ignore: Unreachable code error
        lottieRef.current.play();
    };
    return (
        <div className={_c(styles, "icon mx-auto")}>
            <span className="ng-lottie"><GifIcon
                animationGif={loadingGif}
                animationStop={loadingGif}
                height={customStyle.height}
                width={customStyle.width}
                alt="wait"
                durationMilliSecond={10000000000}
            /></span>
        </div>
    );
}

export default Spinner;

